// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const meowth_galar: PokeData = {
  "id": 10161,
  "name": "meowth-galar",
  "height": 4,
  "weight": 75,
  "base_experience": 58,
  "types": [
    PokeType.STEEL
  ],
  "api_moves": [
    "pay-day",
    "scratch",
    "thrash",
    "growl",
    "screech",
    "fury-swipes",
    "slash",
    "swagger",
    "metal-claw",
    "fake-out",
    "taunt",
    "metal-sound",
    "hone-claws"
  ],
  "moves": [
    "scratch",
    "growl",
    "metal-claw",
    "metal-sound",
    "steel-beam",
    "metal-rush",
    "magnet-pull",
    "iron-defense",
    "scrap-throw",
    "meteor-mash",
    "magnet-bomb",
    "behemoth-bash"
  ],
  "evolution_chain": {
    "id": 22,
    "item": null,
    "species": [
      {
        "name": "meowth",
        "order": 57,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "persian",
        "order": 58,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 52,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "perrserker",
        "order": 863,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": 52,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 98,
    "speed": 80,
    "ability_power": 130
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "galar"
} as const;
